import { formatDateStringToLocalDate, withoutCommasOrDots } from '../helpers/utils'
import { CommunityDTO } from './community'
import { BasicUserDTO, UserDTO } from './users'

export interface CommentDTO {
    id: string
    user: UserDTO
    content: string
    dateCreated: string
    edited: boolean
}

export interface LikeDTO {
    user: UserDTO
}

export interface PostDTO {
    id: string
    title: string
    content: string
    image: string
    author: UserDTO
    dateCreated: string
    comments: CommentDTO[]
    likes: LikeDTO[]
    status: number
    rejectionReason: string
    edited: boolean
    createdByAdmin: boolean
    community: CommunityDTO
    event: boolean
    benefit: boolean
    dayOfTheEvent: string
    attendees: UserDTO[]
    link: string
}

export class SimplePostDTO {
    title: string
    content: string
    image: null | string
    dayOfEvent: string = ''
    event: boolean = false
    link: string = ''

    constructor(info: PostDTO) {
        this.title = info.title
        this.content = info.content
        this.image = info.image
        this.dayOfEvent = info.dayOfTheEvent
        this.event = info.event
        this.link = info.link
    }
}

export enum Currency {
    ARS = 'ARS',
    USD = 'USD',
    EUR = 'EUR',
    BRL = 'BRL',
    MXN = 'MXN',
}

export enum Frequency {
    HOURLY = 'HOURLY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    YEARLY = 'YEARLY',
}

export enum JobPeriod {
    INTERNSHIP = 'INTERNSHIP',
    PART_TIME = 'PART_TIME',
    FULL_TIME = 'FULL_TIME',
}

export enum Modality {
    IN_PERSON = 'PRESENCIAL',
    REMOTE = 'REMOTO',
    HYBRID = 'HIBRIDO',
}

export interface Salary {
    currency: Currency
    frequency: Frequency
    amount: number
    period: JobPeriod
}

export interface JobPostDTO {
    id: string
    title: string
    description: string
    companyLogo: string
    company: string
    location: string
    modality: Modality
    salary: Salary
    finishDate: string
    abilities: string[]
    contact: string
    active: boolean
    userApplied: boolean
    applicants: BasicUserDTO[]
}

export class SimpleJobPostDTO {
    id: string
    title: string
    description: string
    companyLogo: string
    company: string
    location: string
    modality: Modality
    currency: Currency
    frequency: Frequency
    amount: string
    jobPeriod: JobPeriod
    finishDate: string
    abilities: string[]
    contact: string
    active: boolean
    applicants: BasicUserDTO[]

    constructor(info: JobPostDTO) {
        this.id = info.id
        this.title = info.title
        this.description = info.description
        this.companyLogo = info.companyLogo
        this.company = info.company
        this.location = info.location
        this.modality = info.modality
        this.currency = info.salary.currency
        this.frequency = info.salary.frequency
        this.amount = info.salary.amount.toString()
        this.jobPeriod = info.salary.period
        this.finishDate = info.finishDate
        this.abilities = info.abilities
        this.contact = info.contact
        this.active = info.active
        this.applicants = info.applicants
    }
}

export class RequestJobPostDTO {
    title: string
    description: string
    companyLogo: string
    company: string
    location: string
    modality: Modality
    salary: Salary
    finishDate: string
    abilities: string[]
    contact: string

    constructor(info: SimpleJobPostDTO) {
        this.title = info.title
        this.description = info.description
        this.companyLogo = info.companyLogo
        this.company = info.company
        this.location = info.location
        this.modality = info.modality
        this.salary = {
            currency: info.currency,
            frequency: info.frequency,
            amount: withoutCommasOrDots(info.amount as string),
            period: info.jobPeriod,
        }
        this.finishDate = formatDateStringToLocalDate(info.finishDate)
        this.abilities = info.abilities
        this.contact = info.contact
    }
}

export class RequestEditJobPostDTO {
    id: string
    title: string
    description: string
    companyLogo: string
    company: string
    location: string
    modality: Modality
    salary: Salary
    finishDate: string
    abilities: string[]
    contact: string
    active: boolean

    constructor(info: SimpleJobPostDTO) {
        this.id = info.id
        this.title = info.title
        this.description = info.description
        this.companyLogo = info.companyLogo
        this.company = info.company
        this.location = info.location
        this.modality = info.modality
        this.salary = {
            currency: info.currency,
            frequency: info.frequency,
            amount: withoutCommasOrDots(info.amount as string),
            period: info.jobPeriod,
        }
        this.finishDate = formatDateStringToLocalDate(info.finishDate)
        this.abilities = info.abilities
        this.contact = info.contact
        this.active = info.active
    }
}
